import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { typography } from './typography';
import components from './components';
import breakpoints from './breakpoints';
const customTheme = {
    typography,
    components,
    breakpoints,
};
export { default as Colors } from './colors';
export const theme = createTheme(customTheme);
export default responsiveFontSizes(theme);
//# sourceMappingURL=index.js.map